import styled, { css } from 'styled-components';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScGameError = styled.div<{ isAutoHeight?: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: ${({ theme }) => theme.grayDarkColor};
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 32px 16px;


  ${({ isAutoHeight }) =>
    isAutoHeight &&
    css`
      position: relative;
      padding: 0;
    `}
  
  .lock {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};
    margin-bottom: 32px;
    svg {
      width: 30px;
      height: 40px;
    }
  }
  img {
    width: 80px;
    height: auto;
    vertical-align: bottom;
    margin-bottom: 32px;
  }
  p {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    letter-spacing: 0.03em;
    max-width: 462px;
    text-transform: uppercase;
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-transform: none;
      display: block;
      padding-top: 8px;
    }
    strong {
      color: ${({ theme }) => theme.secondaryColor};
    }
    @media (${device.mobile}) {
      font-size: 20px;
      line-height: 28px;
    }
  }
  .button-wrap {
    width: 100%;
    max-width: 336px;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    button {
      width: 160px;
      height: 40px;
      padding: 0;
      text-align: center;

      &:first-child {
        button {
          border: none;
          background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.16)};
        }
        &:hover {
          button {
            color: ${({ theme }) => theme.whiteColor};
            background: ${({ theme }) => theme.secondaryColor};
          }
        }
      }
      @media (${device.mobileXS}) {
        width: 48%;
        button {
          width: 100%;
          min-width: 0;
        }
      }
    }
  }
  &.it,
  &.pt,
  &.pt-br,
  &.sl,
  &.no,
  &.fr-ca,
  &.fr-ch,
  &.de {
    @media (${device.mobileXS}) {
      .button-wrap {
        a {
          button {
            font-size: 12px;
          }
        }
      }
    }
  }

  .error-title {
    text-align: center;
    ${typography.headline2};
    margin-bottom: 12px;

    @media (${device.mobile}) {
      ${typography.headline2mobile};
    }
  }

  .error-subtitle {
    text-align: center;
    ${typography.body1regular};

    text-transform: none;
    color: ${({ theme }) => theme.blackLightColor};
  }

  .not-auth-buttons {
    width: 100%;
    max-width: 368px;
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 32px;
    button {
      width: 180px;
      height: 40px;
      padding: 0;
      text-align: center;
    }
    @media (${device.mobileXS}) {
      button {
        width: 48%;
        min-width: 0;
      }
    }
  }
`;
